export default "__VITE_ASSET__C117$C3L__"